/** Labels and option lists for the Assets & Stock register (Phase 1). */

export const ASSET_CATEGORIES = [
  { value: 'power_tools', label: 'Power tools' },
  { value: 'hand_tools', label: 'Hand tools' },
  { value: 'test_instruments', label: 'Test instruments' },
  { value: 'ladders_access', label: 'Ladders & access' },
  { value: 'safety_equipment', label: 'Safety equipment' },
  { value: 'it_equipment', label: 'IT equipment' },
  { value: 'office_equipment', label: 'Office equipment' },
  { value: 'plant_machinery', label: 'Plant & machinery' },
  { value: 'other', label: 'Other' },
];

export const ASSET_STATUSES = [
  { value: 'in_service', label: 'In service' },
  { value: 'in_storage', label: 'In storage' },
  { value: 'assigned', label: 'Assigned' },
  { value: 'under_repair', label: 'Under repair' },
  { value: 'lost', label: 'Lost' },
  { value: 'stolen', label: 'Stolen' },
  { value: 'sold', label: 'Sold' },
  { value: 'scrapped', label: 'Scrapped' },
  { value: 'disposed', label: 'Disposed' },
];

export const LOCATION_TYPES = [
  { value: 'office', label: 'Office' },
  { value: 'stores', label: 'Stores' },
  { value: 'van', label: 'Van' },
  { value: 'site', label: 'Site' },
  { value: 'employee', label: 'Employee' },
  { value: 'other', label: 'Other' },
];

export const DOCUMENT_TYPES = [
  { value: 'purchase_receipt', label: 'Purchase receipt' },
  { value: 'warranty_certificate', label: 'Warranty certificate' },
  { value: 'warranty_registration', label: 'Warranty registration' },
  { value: 'calibration_certificate', label: 'Calibration certificate' },
  { value: 'service_report', label: 'Service report' },
  { value: 'repair_invoice', label: 'Repair invoice' },
  { value: 'manual', label: 'Manual' },
  { value: 'photo', label: 'Photo' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'disposal', label: 'Disposal' },
  { value: 'other', label: 'Other' },
];

export const HISTORY_EVENT_TYPES = [
  { value: 'calibration', label: 'Calibration' },
  { value: 'service', label: 'Service' },
  { value: 'repair', label: 'Repair' },
  { value: 'inspection', label: 'Inspection' },
  { value: 'warranty_claim', label: 'Warranty claim' },
  { value: 'assignment_change', label: 'Assignment change' },
  { value: 'location_change', label: 'Location change' },
  { value: 'disposal', label: 'Disposal' },
  { value: 'other', label: 'Other' },
];

export const PURCHASE_DESTINATION_TYPES = [
  { value: 'expense', label: 'Expense (default)' },
  { value: 'asset', label: 'Add to asset register' },
  { value: 'stock', label: 'Add to stock' },
];

export const VAT_RECLAIM_STATUSES = [
  { value: 'unreviewed', label: 'Unreviewed' },
  { value: 'likely_eligible', label: 'Likely eligible' },
  { value: 'excluded', label: 'Excluded' },
  { value: 'accountant_reviewed', label: 'Accountant reviewed' },
  { value: 'claimed', label: 'Claimed' },
];

export const labelFor = (options, value) =>
  options.find((o) => o.value === value)?.label ?? value ?? '—';

export const formatAssetDate = (dateString) => {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('en-GB');
};

export const formatAssetCurrency = (amount) => {
  if (amount == null || amount === '') return '—';
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount);
};

export const formatFileSize = (bytes) => {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** ISO date string for N days from today (for list filters). */
export const dateInDays = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};
